// @ts-check
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/storage'
import 'firebase/compat/functions'
import 'firebase/compat/firestore'
import { initializeAuth, browserLocalPersistence, fetchSignInMethodsForEmail } from 'firebase/auth'
import firebaseConfig from './firebaseConfig'
import { getFirestore } from 'firebase/firestore'
import { getRemoteConfig, fetchAndActivate, getValue, type RemoteConfig } from 'firebase/remote-config'
import { Platform } from 'react-native'

// Initialize Firebase App
const defaultApp = firebase.initializeApp(firebaseConfig)
initializeAuth(defaultApp, { persistence: browserLocalPersistence })

export const app = defaultApp

export const auth = firebase.auth()

export const FetchSignInMethodsForEmail = fetchSignInMethodsForEmail

firebase.firestore().settings({ experimentalForceLongPolling: true, experimentalAutoDetectLongPolling: false, merge: true })

export const rootDb = firebase.firestore()

export const rootDbModular = getFirestore(defaultApp)

export const functions = firebase.functions()

export const emailAuthProvider = firebase.auth.EmailAuthProvider

export const storage = firebase.storage().ref()

export const fieldValue = firebase.firestore.FieldValue

export const fieldPath = firebase.firestore.FieldPath

export const remoteConfig: RemoteConfig | null = Platform.OS === 'web' ? getRemoteConfig(defaultApp) : null
// Resolves once the boot fetch+activate settles, with how it settled: 'fetched' | 'cache' | 'error'
// (mirrors the native module — see its comment for semantics). Never rejects. See ATL-531/533.
export const remoteConfigReady: Promise<'fetched' | 'cache' | 'error'> = (() => {
  if (!remoteConfig) return Promise.resolve('error' as const)
  remoteConfig.settings.minimumFetchIntervalMillis = 60000
  return fetchAndActivate(remoteConfig)
    .then(activated => (activated ? ('fetched' as const) : ('cache' as const)))
    .catch((err: unknown) => {
      console.log(err)
      return 'error' as const
    })
})()

// On-demand refetch (e.g. on app foreground) — mirrors the native module. Never rejects.
export const refetchRemoteConfig = (): Promise<'fetched' | 'cache' | 'error'> => {
  if (!remoteConfig) return Promise.resolve('error' as const)
  return fetchAndActivate(remoteConfig)
    .then(activated => (activated ? ('fetched' as const) : ('cache' as const)))
    .catch(() => 'error' as const)
}

export const getRemoteConfigValue = (key: string): string => {
  if (!remoteConfig) return ''
  return getValue(remoteConfig, key).asString()
}

// Epoch ms of the LAST SUCCESSFUL Remote Config fetch, or -1 when the SDK has never fetched.
// The gate uses this to tell a fresh policy from one a device has been unable to refresh for
// days — an activated-but-ancient allowlist is indistinguishable from a current one by value
// alone (ATL-786). Never throws.
export const getRemoteConfigFetchTimeMillis = (): number => {
  if (!remoteConfig) return -1
  try {
    return remoteConfig.fetchTimeMillis
  } catch {
    return -1
  }
}
